import React, { memo } from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import {
    CarrierTypeModelSimpleTextDataKeys,
    CarrierTypeModelSimpleTextData,
} from 'fulogics-ui-web/dist/layout/components/carrier-type-model-simple-text/CarrierTypeModelSimpleText';
import { withStoreItemByKey } from 'fulogics-ui-web/dist/layout/hoc/withStoreItemByKey';
import { CarrierTypesStore } from '../../../../../store/models/CarrierTypesModel';

const CarrierNameSimpleText = memo(({ data }: { data?: CarrierTypeModelSimpleTextData }) => {
    return <>{data?.name || ''}</>;
});

const CarrierNameSimpleTextAsync = withStoreItemByKey(CarrierNameSimpleText);

const CarrierTypeAsyncColumnTemplate = (props: CellTemplateProps) => {
    const data = gridCellData(props);

    return (
        <>
            <CarrierNameSimpleTextAsync
                id={data}
                store={CarrierTypesStore}
                keys={CarrierTypeModelSimpleTextDataKeys}
            />
        </>
    );
};

export const CarrierTypeAsyncColumnTemplateDefaultProps = {};

export const CarrierTypeAsyncColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type CarrierTypeAsyncColumnTemplateData = {
    id?: string;
};

export const CarrierTypeAsyncColumnTemplateDataKeys = ['id'];

export default CarrierTypeAsyncColumnTemplate;
